import type { AppService } from "adl-gen/app-service";

export type UploadFileResult =
  | {
      kind: "success";
      fileId: string;
    }
  | {
      kind: "error";
    };

export const UploadFile = async (
  isDevelopment: boolean,
  service: AppService,
  file: File,
  authToken: string,
): Promise<UploadFileResult> => {
  return uploadFile(isDevelopment, service, file, authToken, false);
};

export const UploadFileAsPublicAsset = async (
  isDevelopment: boolean,
  service: AppService,
  file: File,
  authToken: string,
): Promise<UploadFileResult> => {
  return uploadFile(isDevelopment, service, file, authToken, true);
};

const uploadFile = async (
  isDevelopment: boolean,
  service: AppService,
  file: File,
  authToken: string,
  publicAsset: boolean,
): Promise<UploadFileResult> => {
  const uploadDetails = publicAsset
    ? await service.getPublicAssetUploadUrl({ filename: file.name })
    : await service.getUploadUrl({ filename: file.name });

  const arrayBuffer = await file.arrayBuffer();

  const resp = await fetch(uploadDetails.uploadUrl, {
    method: uploadDetails.method,
    body: arrayBuffer,
    headers: {
      "Content-Type": file.type,
    },

    // This bit is only relevant for local blobstore config
    ...(isDevelopment && { headers: { "X-Auth-Token": authToken } }),
  });

  if (resp.ok) {
    return { kind: "success", fileId: uploadDetails.storedFileId };
  }
  return { kind: "error" };
};

export const downloadFileAs = async (url: string, fileName: string) => {
  const resp = await fetch(url);
  if (!resp.ok) {
    throw new Error("Failed to download file");
  }
  const blob = await resp.blob();
  const aLink = document.createElement("a");
  aLink.href = URL.createObjectURL(blob);
  aLink.download = fileName;
  document.body.appendChild(aLink);
  aLink.click();
  document.body.removeChild(aLink);
  URL.revokeObjectURL(aLink.href);
};
